import React from 'react';
import { Link } from 'react-router-dom';
import { ServiceCard } from '../components/ServiceCard';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';

export const HomePage: React.FC = () => {
  const { user } = useAuth();
  
  const services = [
    {
      id: 'jump-start',
      title: 'Jump Start',
      description: 'Battery dead? We\'ll get you back on the road quickly.',
      icon: 'fas fa-bolt',
    },
    {
      id: 'tire-change',
      title: 'Tire Change',
      description: 'Flat tire? Our technicians will replace it with your spare.',
      icon: 'fas fa-car',
    },
    {
      id: 'fuel-delivery',
      title: 'Fuel Delivery',
      description: 'Out of gas? We\'ll bring fuel directly to your location.',
      icon: 'fas fa-gas-pump',
    },
    {
      id: 'lockout',
      title: 'Lockout Service',
      description: 'Locked out of your car? We\'ll help you get back in safely.',
      icon: 'fas fa-key',
    },
  ];

  return (
    <div className="home-page">
      <header className="home-header">
        <div className="logo-container">
        <img src="/OMWA-long-blk.png" alt="OMWA Logo" />
        </div>
        <h2 className="welcome-text">Proffesional Roadside Assistance</h2>
        {/* <p className="subtitle">when you need it most</p> */}
      </header>

      <main className="home-main">
        <section className="services-section">
          <h3 className="section-title">Our Services</h3>
          <div className="services-grid">
            {services.map((service) => (
              <Link key={service.id} to={`/request-service?service=${service.id}`}>
                <ServiceCard
                  title={service.title}
                  description={service.description}
                  icon={service.icon}
                />
              </Link>
            ))}
          </div>
        </section>

        {user && (user.user_metadata?.role === 'technician') && (
          <section className="technician-dashboard-section">
            <div className="dashboard-card">
              <div className="dashboard-header">
                <div className="dashboard-icon">
                  <i className="fas fa-tools"></i>
                </div>
                <div className="dashboard-info">
                  <h3>Technician Dashboard</h3>
                  <p>Manage service requests and track your assignments</p>
                </div>
              </div>
              <div className="dashboard-actions">
                <Link to="/technician" className="btn btn-primary dashboard-btn">
                  <i className="fas fa-tachometer-alt"></i>
                  Open Dashboard
                </Link>
              </div>
            </div>
          </section>
        )}

        {/* <section className="emergency-section">
          <h3 className="emergency-title">Emergency?</h3>
          <p className="emergency-text">
            Call us directly at <strong>(555) 123-4567</strong> for immediate assistance
          </p>
        </section> */}

        {!user && (
          <section className="auth-section">
            <div className="auth-buttons">
              <Link to="/signup" className="btn btn-primary">Sign Up</Link>
              <Link to="/login" className="btn btn-outline">Sign In</Link>
            </div>
          </section>
        )}

      </main>
    </div>
  );
};
